import { QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './Config/app/i18n';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RouterProvider } from 'react-router-dom';
import { AnalyticsProvider } from 'use-analytics';
import { entryQueryClientConfig } from './Config/api/entryQueryClient.config';
import { PUBLIC_KEY_V3 } from './Config/app/reCaptcha';
import router from './Config/app/router/entry.router';
import analytics from './Config/libs/analytics';
import './Domain/style/app.scss';
import './Config/api/httpClient.config';
import { Toaster } from '@/Domain/components/Shared/Toast/Toast';

// Initialize PostHog for A/B testing on signup/login pages
if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.register({ 'web-type': 'entry' });
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
  });

  posthog.debug(false);

  // Expose posthog to window for debugging (feature flag overrides, etc.)
  window.posthog = posthog;
}

if (!document.getElementById('entry')) {
  throw new Error('Entry point not found');
}

const root = createRoot(document.getElementById('entry') as HTMLElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={entryQueryClientConfig}>
      <AnalyticsProvider instance={analytics}>
        <GoogleReCaptchaProvider reCaptchaKey={PUBLIC_KEY_V3}>
          <PostHogProvider client={posthog}>
            <Toaster />
            <RouterProvider router={router} />
          </PostHogProvider>
        </GoogleReCaptchaProvider>
      </AnalyticsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
